import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class Proxy extends ProxyBase {
  postPeerAnalysisSearch(params) {
    return this.post('search', params)
  }
}

export default new Proxy('DomesticSearch/')
